module.exports = __webpack_public_path__ + "img/icon_copy_code.3d50e233.svg";